import { PolymorphicComponentProps } from "../../types/polymorhphic-component-types";

type DatadogMaskProps<C extends React.ElementType> = PolymorphicComponentProps<
  C,
  { children?: React.ReactNode }
>;

/**
 * Masks its content in Datadog session replays (`data-dd-privacy="mask"`).
 *
 * Note: with `defaultPrivacyLevel="mask"` set on the Datadog RUM init, page
 * content is already masked by default, so this wrapper is largely redundant
 * for privacy. It is kept for the existing call sites (some of which also rely
 * on `data-dd-action-name`). To reveal an element instead, use `DatadogPrivacy`.
 */
export const DatadogMask = <C extends React.ElementType = "span">({
  as: Component = "span",
  children,
  className,
  ...rest
}: DatadogMaskProps<C>) => {
  return (
    <Component
      {...rest}
      className={`dd-privacy-mask${className ? ` ${className}` : ""}`}
      data-dd-privacy="mask"
    >
      {children}
    </Component>
  );
};
